'use client'

import * as React from 'react'
import * as SwitchPrimitive from '@radix-ui/react-switch'

import { cn } from '@/lib/utils'

function Switch({ className, ...props }: React.ComponentProps<typeof SwitchPrimitive.Root>) {
    return (
        <SwitchPrimitive.Root
            data-slot="switch"
            className={cn(
                'peer tw:data-[state=checked]:bg-blue-500 tw:data-[state=unchecked]:bg-gray-300 tw:focus-visible:border-ring tw:focus-visible:ring-ring/50',
                'tw:dark:data-[state=unchecked]:bg-input/80 tw:inline-flex tw:h-[1.15rem] tw:w-8 tw:shrink-0 tw:items-center tw:!rounded-full tw:border',
                'tw:border-transparent tw:shadow-xs tw:transition-all tw:outline-none tw:focus-visible:ring-[3px] tw:disabled:cursor-not-allowed tw:w-[38px]',
                'tw:disabled:opacity-50 tw:h-5',
                className,
            )}
            {...props}
        >
            <SwitchPrimitive.Thumb
                data-slot="switch-thumb"
                className={cn(
                    'tw:bg-red-500 tw:dark:data-[state=unchecked]:bg-foreground tw:dark:data-[state=checked]:bg-white tw:pointer-events-none tw:block',
                    'tw:size-4 tw:rounded-full tw:ring-0 tw:transition-transform tw:data-[state=checked]:translate-x-[calc(120%)]',
                    'tw:data-[state=unchecked]:translate-x-[2px]',
                )}
            />
        </SwitchPrimitive.Root>
    )
}

export { Switch }
